import React from "react";
import { Toast, Button, List, InputItem } from "antd-mobile";
import { post } from "../../utils/request.js";
import { href, viewPort } from "../../utils/util.js";

import api from "./api.js";
import { wxfx } from "../../utils/wxfx.js";

import "./index.less";
let timer;
class vehicleInquiryChange extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      urlOps: {},
      modalType: false,
      selectType: false,
      vCode: false,
      second: 60,
      phoneNumber: "",
      imageCode: "",
      messageCode: "",
      imgUrl: "",
      agreementUrl: "",
      recordCode: "",
      province: "",
      city: "",
    };
  }

  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = decodeURIComponent(window.location.hash).split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }

      this.setState({
        urlOps: ops,
      });
    }
  }
  // 获取图片验证码
  getImgCode() {
    const { urlOps, phoneNumber } = this.state;
    this.setState(
      {
        modalImgCodeType: true,
      },
      () => {
        post({
          url: api.imageCode,
          data: {
            phoneNumber: phoneNumber,
            businessType: "CAR_INSURANCE_INQUIRY",
          },
        }).then(
          (res) => {
            if (res.result === "success") {
              this.setState({
                imgUrl: "data:image/jpg;base64," + res.data,
              });
            } else {
              Toast.info(res.msg, 1);
            }
          },
          (res) => {
            Toast.info("图片验证码获取失败", 1);
          }
        );
      }
    );
  }

  // 获取验证码
  getMessageCode() {
    clearInterval(timer);
    const { urlOps, phoneNumber, imageCode } = this.state;
    let _this = this;
    post({
      url: api.messageCode,
      data: {
        phoneNumber: phoneNumber,
        audio: 0,
        imageCode: imageCode,
        businessType: "CAR_INSURANCE_INQUIRY",
      },
    }).then(
      (res) => {
        if (res.result === "success") {
          _this.setState(
            {
              second: 59,
              recordCode: res.data,
              modalImgCodeType: false,
              vCode: true,
            },
            () => {
              let { second } = _this.state;
              timer = setInterval(function () {
                if (second < 0) {
                  clearInterval(timer);
                  _this.setState({
                    vCode: false,
                    second: 60,
                  });
                } else {
                  _this.setState({
                    second: second--,
                  });
                }
              }, 1000);
            }
          );
        } else {
          clearInterval(timer);
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        clearInterval(timer);
        Toast.info(res.msg, 1);
      }
    );
  }

  // 更换
  register() {
    const { urlOps, phoneNumber, messageCode, recordCode, province, city } =
      this.state;
    const viewPortData = viewPort();
    let app_stoken = "";
    if (viewPortData.ios || viewPortData.iPhone || viewPortData.iPad) {
      if (window.webkit) {
        app_stoken = window.prompt("getAppToken", "");
      }
    } else {
      if (window.huilian && window.huilian.getAppToken) {
        app_stoken = window.huilian.getAppToken();
      }
    }
    post({
      url: api.validateMessageCode + "?app_stoken=" + app_stoken,
      data: {
        businessType: "CAR_INSURANCE_INQUIRY",
        phoneNumber,
        messageCode,
      },
    }).then(
      (res) => {
        if (res.result === "success") {
          Toast.info("更换成功", 1);
          let url = encodeURI(
            "/vehicleInquiryInputPage?phoneNumber=" +
              phoneNumber +
              "&carPlateNumber=" +
              urlOps.carPlateNumber +
              "&contactName=" +
              urlOps.contactName
          );
          href(url);
        } else {
          Toast.info(res.msg, 1);
        }
      },
      (res) => {
        Toast.info("更换失败", 1);
      }
    );
    // this.viewPort();
  }
  // viewPort =  () => {
  //     let device_type = navigator.userAgent.toLowerCase();
  //     console.log(device_type);
  // }

  render() {
    const {
      modalImgCodeType,
      selectType,
      vCode,
      second,
      phoneNumber,
      imgUrl,
      imageCode,
      messageCode,
      urlOps,
      agreementUrl,
      recordCode,
    } = this.state;
    // console.log(urlOps)
    return (
      <div className="vehicleInquiryChangeBox">
        <div className="registerBox">
          <div>
            <div className="inputBox">
              <List style={{ marginBottom: "0.23rem" }}>
                <InputItem
                  placeholder="请输入手机号"
                  type="money"
                  moneyKeyboardAlign="right"
                  onChange={(val) => {
                    this.setState({
                      phoneNumber: val,
                    });
                  }}
                >
                  手机号
                </InputItem>
                <InputItem
                  placeholder=""
                  type="money"
                  moneyKeyboardAlign="left"
                  extra={
                    vCode ? (
                      <span style={{ fontSize: "13px" }}>
                        {second}秒后重新获取
                      </span>
                    ) : (
                      <a
                        style={{ fontSize: "13px" }}
                        onClick={() => {
                          if (phoneNumber.length !== 11) {
                            Toast.info("请填写正确的手机号码", 1);
                            return;
                          }
                          this.getImgCode();
                        }}
                      >
                        获取验证码
                      </a>
                    )
                  }
                  onChange={(val) => {
                    this.setState({
                      messageCode: val,
                    });
                  }}
                >
                  验证码
                </InputItem>
              </List>
              {recordCode ? (
                <span>请输入接收到的验证码（编号{recordCode}）</span>
              ) : (
                ""
              )}
            </div>
            <div
              className="reward_3_row"
              onClick={() => {
                if (phoneNumber.length !== 11) {
                  Toast.info("请填写正确的手机号码", 1);
                  return;
                }
                if (messageCode.length === 0) {
                  Toast.info("请填写验证码", 1);
                  return;
                }
                this.register();
              }}
            >
              确定
            </div>
          </div>
        </div>
        {modalImgCodeType ? (
          <div className="modalImgCodeBox">
            <div>
              <h3>图形验证</h3>
              <div className="inputBox">
                <input
                  type="text"
                  placeholder="图形验证码"
                  onChange={(e) => {
                    this.setState({
                      imageCode: e.target.value,
                    });
                  }}
                />
                <img
                  src={imgUrl}
                  onClick={() => {
                    this.getImgCode();
                  }}
                />
              </div>
              <div className="btnBox">
                <a
                  onClick={() => {
                    this.setState({
                      modalImgCodeType: false,
                      imageCode: "",
                    });
                  }}
                >
                  取消
                </a>
                <a
                  onClick={() => {
                    if (imageCode.length === 0) {
                      Toast.info("请填写图形验证码", 1);
                      return;
                    }
                    this.getMessageCode();
                  }}
                >
                  确定
                </a>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default vehicleInquiryChange;



// WEBPACK FOOTER //
// ./src/vehicleInquiry/change/index.js